import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HubspotAuthService } from '../services/hubspot-auth-service';
import { map, of, switchMap, throwError } from 'rxjs';
import { RedirectRouteStorageService } from '../../core/services/redirect-route-storage-service';

@Component({
  selector: 'app-oauth-callback',
  template: `
    <div class="flex items-center justify-center min-h-screen">
      <div class="text-center">
        @if (!done()) {
          <h1 class="text-2xl font-bold mb-4">
            Autenticazione in corso, non chiudere questa pagina
          </h1>
          <div
            class="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto"
          ></div>
          @if (error()) {
            <div class="mt-4 p-4 bg-red-100 text-red-700 rounded">
              {{ error() }}
            </div>
          }
        } @else {
          <h1 class="text-2xl font-bold mb-4">
            Autenticazione completata, puoi chiudere questa pagina
          </h1>
        }
      </div>
    </div>
  `,
})
export class OAuthCallbackComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private hubspotAuthService = inject(HubspotAuthService);
  private redirectRouteStorageService = inject(RedirectRouteStorageService);

  error = signal<string | null>(null);
  done = signal<boolean>(false);

  ngOnInit() {
    this.error.set(null);

    this.route.queryParams
      .pipe(
        switchMap((params) => {
          const { code } = params;

          if (code) {
            return this.hubspotAuthService.handleOAuthCallback(code);
          }

          return throwError(() => new Error('Missing OAuth parameters'));
        }),
      )
      .subscribe({
        next: () => {
          const redirectRoute = this.redirectRouteStorageService.get();
          if (redirectRoute) {
            this.router.navigateByUrl(redirectRoute);
          } else {
            this.done.set(true);
          }
        },
        error: (error) => {
          this.error.set(error.message || 'Authentication failed');
        },
      });
  }
}
